import UserRequests from './UserRequests';

export default UserRequests;
